import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color"],
  _excluded2 = ["children", "closeable", "onClose", "titleText", "type", "use", "floating"];
import styled from 'foundations-theming/utils';
import { Flex } from '../../../components/Flex/Flex';
import { Text } from '../../../components/Text/Text';
import { useTypeCSSObject } from './Alert.helpers';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { CloseButton } from '../../../components/CloseButton/CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledDiv = styled.div.withConfig({
  displayName: "AbstractAlert__StyledDiv",
  componentId: "sc-9376ty-0"
})(({
  $floating,
  $use,
  $typeStyles,
  $cssStyles,
  theme: _theme
}) => {
  const theme = _theme;
  const {
      color
    } = $typeStyles,
    typeStyles = _objectWithoutPropertiesLoose($typeStyles, _excluded);
  return Object.assign({
    paddingInline: theme.space['500'],
    paddingBlock: $use === 'default' ? theme.space['400'] : theme.space['200'],
    textAlign: 'left',
    color: theme.color[color]
  }, $floating && {
    display: 'inline-flex',
    boxShadow: theme.boxShadow['200'],
    maxWidth: '668px',
    wordBreak: 'break-word',
    '@media only screen and (max-width: 768px)': {
      maxWidth: 'calc(100% - 50px)'
    }
  }, typeStyles, $cssStyles);
});
export const AbstractAlert = _ref => {
  let {
      children,
      closeable = false,
      onClose,
      titleText,
      type = 'info',
      use = 'default',
      floating = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);

  // Alert / FireAlarm / Banner styles
  const typeStyles = useTypeCSSObject(type);

  // Enable backwards compatibility with Selenium helpers
  // @see https://git.hubteam.com/HubSpot/hs-selenium/blob/dd3f36670180d811a35ccbca53b6841751ec1ee7/selenium-js-utils/src/UIComponents/alerts.ts#L75-L77
  const className = closeable ? 'alert-dismissable' : '';
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({
    $cssStyles: cssStyles,
    $floating: floating,
    $typeStyles: typeStyles,
    $use: use,
    "aria-atomic": true,
    "aria-live": "polite",
    className: className,
    "data-alert-type": type,
    role: "alert"
  }, domProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexWrap: "wrap",
        flexGrow: 1,
        alignItems: "center",
        columnGap: "500",
        rowGap: "200",
        paddingInlineEnd: closeable ? '600' : '0',
        children: [titleText && /*#__PURE__*/_jsx(Text, {
          as: "h5",
          color: typeStyles.color,
          children: titleText
        }), /*#__PURE__*/_jsx(Flex, {
          flexGrow: 1,
          children: children
        })]
      }), closeable ? /*#__PURE__*/_jsx(CloseButton, {
        onClick: onClose,
        autoFocus: false,
        variant: type === 'banner' ? 'inverse' : 'default'
      }) : null]
    })
  }));
};